/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
'use strict';

const MachineServerEvents = require('./MachineServerMessagingProtocol').EVENTS;
const MachineServerMessageTypes = require('./MachineServerMessagingProtocol').MESSAGE_TYPES;
/**
 * ******************************************************************************************
 * Machine request types
 * ******************************************************************************************
 */

const ADD_INBOX_MESSAGE = 'add_inbox_message';
const CREATE_STREAMSHEET_MESSAGE_TYPE = 'streamsheet_create';
const GET_MACHINES_MESSAGE_TYPE = 'machineserver_machines';
const DELETE_MACHINE_MESSAGE_TYPE = 'machine_delete';
const DELETE_STREAMSHEET_MESSAGE_TYPE = 'streamsheet_delete';
const LOAD_MACHINE_MESSAGE_TYPE = 'machine_load';
const UNLOAD_MACHINE_MESSAGE_TYPE = 'machine_unload';
const RENAME_MACHINE_MESSAGE_TYPE = 'machine_rename';
const PAUSE_MACHINE_MESSAGE_TYPE = 'machine_pause';
const PING_MACHINESOCKETSERVER_MESSAGE_TYPE = 'ping_machinesocketserver';
const SAVE_MACHINE_AS_MESSAGE_TYPE = 'machine_save_as';
const SAVE_MACHINE_COPY_MESSAGE_TYPE = 'machine_save_copy';
const SET_NAMED_CELLS = 'set_named_cells';
const SET_SHEET_CELLS = 'set_sheet_cells';
const START_CONTROL_MODE_MESSAGE_TYPE = 'machine_start_control_mode';
const CONFIRM_PROCESSED_MACHINE_STEP = 'confirm_processed_machine_step';
const START_MACHINE_MESSAGE_TYPE = 'machine_start';
const START_MACHINES_MESSAGE_TYPE = 'machines_start';
const STEP_MACHINE_MESSAGE_TYPE = 'machine_step';
const STOP_CONTROL_MODE_MESSAGE_TYPE = 'machine_stop_control_mode';
const STOP_MACHINE_MESSAGE_TYPE = 'machine_stop';
const STOP_MACHINES_MESSAGE_TYPE = 'machines_stop';
const SUBSCRIBE_MACHINE_MESSAGE_TYPE = 'machine_subscribe';
const REDO_MESSAGE_TYPE = 'redo';
const UNDO_MESSAGE_TYPE = 'undo';
const UPDATE_MACHINE_IMAGE_MESSAGE_TYPE = 'update_machine_image';
const UPDATE_MACHINE_TITLE_IMAGE_MESSAGE_TYPE = 'update_machine_title_image';
const UPDATE_PROCESS_SHEET_MESSAGE_TYPE = 'update_process_sheets';
const UNSUBSCRIBE_MACHINE_MESSAGE_TYPE = 'machine_unsubscribe';
const LOAD_SUBSCRIBE_MACHINE_MESSAGE_TYPE = 'machine_load_subscribe';
const CONFIRM_LOAD_SUBSCRIBE_MACHINE_MESSAGE_TYPE = 'machine_confirm_load_subscribe';


/**
 * ******************************************************************************************
 * General request types
 * ******************************************************************************************
 */

const COMMAND_MESSAGE_TYPE = 'command';

/**
 * ******************************************************************************************
 * Events
 * ******************************************************************************************
 */

const CELL_EVENT_ERROR = MachineServerEvents.CELL_EVENT_ERROR;
const CONNECTION_SHEET_EVENT = MachineServerEvents.CONNECTION_SHEET_EVENT;
const GATEWAY_DISCONNECTED_EVENT = 'gateway_disconnected';
const SESSION_INIT_EVENT = 'session_init';
const LICENSE_INFO_EVENT = 'license_information';
const MACHINE_RENAME_EVENT = 'machine_rename';
const MACHINE_VIEW_SETTINGS_EVENT = 'machine_view_settings';
const MACHINE_FUNCTIONS_EVENT = 'machine_functions';
const MACHINE_SERVER_CONNECTED_EVENT = 'machineserver_connected';
const MACHINE_SERVER_DISCONNECTED_EVENT = 'machineserver_disconnected';
const MACHINE_STATE_EVENT = 'machine_state';
const MACHINE_STEP_EVENT = 'machine_step';
const MESSAGE_ADD_EVENT = 'message_add';
const RESPOND_EVENT = 'respond';
const SHEET_STEP_EVENT = 'sheet_step';
const SHEET_UPDATE_EVENT = 'sheet_update';
const SELECTION_EVENT = 'selection';
const MESSAGE_BOX_CLEAR = 'message_box_clear';
const MESSAGE_PUT = 'message_put';
const MESSAGE_POP = 'message_pop';
const MESSAGE_CHANGED = 'message_changed';
const SERVICE_EVENT = 'service';
const SERVICE_CONNECTED_EVENT = 'service_connected';
const SERVICE_DISCONNECTED_EVENT = 'service_disconnected';
const STREAMSHEET_MESSAGE_ATTACHED = 'streamsheet_message_attached';
const STREAMSHEET_MESSAGE_DETACHED = 'streamsheet_message_detached';
const STREAMSHEET_STEP_EVENT = 'streamsheet_step';
const STREAMSHEET_STREAM_UPDATE_TYPE = 'streamsheet_stream_update';
const STREAMSHEET_STREAM_UPDATED = 'streamsheet_stream_updated';
const USER_JOINED_EVENT = 'user_joined';
const USER_LEFT_EVENT = 'user_left';
const USER_LOGIN_MESSAGE_TYPE = 'user_login';
const USER_LOGOUT_MESSAGE_TYPE = 'user_logout';
const REDIRECT = 'redirect';
const MACHINE_SUBSCRIBED_EVENT = 'machine_subscribed_event';
const MACHINE_UNSUBSCRIBED_EVENT = 'machine_unsubscribed_event';

module.exports = {
	MESSAGE_TYPES: {
		// Machine request types
		ADD_INBOX_MESSAGE,
		CREATE_STREAMSHEET_MESSAGE_TYPE,
		DELETE_DATA: MachineServerMessageTypes.DELETE_DATA,
		DELETE_MACHINE_MESSAGE_TYPE,
		DELETE_STREAMSHEET_MESSAGE_TYPE,
		GET_MACHINES_MESSAGE_TYPE,
		GET_CELL_RAW_VALUE: MachineServerMessageTypes.GET_CELL_RAW_VALUE,
		LOAD_MACHINE_MESSAGE_TYPE,
		UNLOAD_MACHINE_MESSAGE_TYPE,
		LOAD_SUBSCRIBE_MACHINE_MESSAGE_TYPE,
		MACHINE_UPDATE_SETTINGS_MESSAGE_TYPE: MachineServerMessageTypes.MACHINE_UPDATE_SETTINGS,
		OPEN_MACHINE_MESSAGE_TYPE: MachineServerMessageTypes.OPEN_MACHINE_MESSAGE_TYPE,
		PAUSE_MACHINE_MESSAGE_TYPE,
		RENAME_MACHINE_MESSAGE_TYPE,
		STREAMSHEET_STREAM_UPDATE_TYPE,
		PING_MACHINESOCKETSERVER_MESSAGE_TYPE,
		SAVE_MACHINE_AS_MESSAGE_TYPE,
		SAVE_MACHINE_COPY_MESSAGE_TYPE,
		SET_DATA: MachineServerMessageTypes.SET_DATA,
		SET_NAMED_CELLS,
		SET_SHEET_CELLS,
		SET_SHEET_CELLS_MESSAGE_TYPE: MachineServerMessageTypes.SET_SHEET_CELLS,
		START_CONTROL_MODE_MESSAGE_TYPE,
		CONFIRM_PROCESSED_MACHINE_STEP,
		START_MACHINE_MESSAGE_TYPE,
		START_MACHINES_MESSAGE_TYPE,
		STEP_MACHINE_MESSAGE_TYPE,
		STOP_CONTROL_MODE_MESSAGE_TYPE,
		STOP_MACHINE_MESSAGE_TYPE,
		STOP_MACHINES_MESSAGE_TYPE,
		SUBSCRIBE_MACHINE_MESSAGE_TYPE,
		REDO_MESSAGE_TYPE,
		UNDO_MESSAGE_TYPE,
		UNSUBSCRIBE_MACHINE_MESSAGE_TYPE,
		UPDATE_MACHINE_IMAGE_MESSAGE_TYPE,
		UPDATE_MACHINE_TITLE_IMAGE_MESSAGE_TYPE,
		UPDATE_PROCESS_SHEET_MESSAGE_TYPE,
		// General request types
		COMMAND_MESSAGE_TYPE,
		MACHINE_ACTION_MESSAGE_TYPE: MachineServerMessageTypes.MACHINE_ACTION_MESSAGE_TYPE,
		USER_LOGIN_MESSAGE_TYPE,
		USER_LOGOUT_MESSAGE_TYPE,
		CONFIRM_LOAD_SUBSCRIBE_MACHINE_MESSAGE_TYPE
	},
	EVENTS: {
		// Events
		CELL_EVENT_ERROR,
		CONNECTION_SHEET_EVENT,
		CUSTOM_INFO_UPDATED: MachineServerEvents.CUSTOM_INFO_UPDATED,
		SESSION_INIT_EVENT,
		GATEWAY_DISCONNECTED_EVENT,
		LICENSE_INFO_EVENT,
		MACHINE_SETTINGS_EVENT: MachineServerEvents.MACHINE_SETTINGS_EVENT,
		MACHINE_MAXIMIZE_SHEET_EVENT: MachineServerEvents.MACHINE_MAXIMIZE_SHEET_EVENT,
		MACHINE_SHOW_OUTBOX_EVENT: MachineServerEvents.MACHINE_SHOW_OUTBOX_EVENT,
		MACHINE_RENAME_EVENT,
		MACHINE_VIEW_SETTINGS_EVENT,
		MACHINE_FUNCTIONS_EVENT,
		MACHINE_SERVER_CONNECTED_EVENT,
		STREAMSHEET_STREAM_UPDATED,
		MACHINE_SERVER_DISCONNECTED_EVENT,
		MACHINE_STATE_EVENT,
		MACHINE_STEP_EVENT,
		MESSAGE_ADD_EVENT,
		NAMED_CELLS_EVENT: MachineServerEvents.NAMED_CELLS_EVENT,
		RESPOND_EVENT,
		SHEET_STEP_EVENT,
		SHEET_UPDATE_EVENT,
		SELECTION_EVENT,
		SERVICE_EVENT,
		MESSAGE_BOX_CLEAR,
		MESSAGE_PUT,
		MESSAGE_POP,
		MESSAGE_CHANGED,
		SERVICE_CONNECTED_EVENT,
		SERVICE_DISCONNECTED_EVENT,
		STREAMSHEET_MESSAGE_ATTACHED,
		STREAMSHEET_MESSAGE_DETACHED,
		STREAMSHEET_ADDED: MachineServerEvents.STREAMSHEET_ADDED,
		STREAMSHEET_REMOVED: MachineServerEvents.STREAMSHEET_REMOVED,
		STREAMSHEET_STEP_EVENT,
		USER_JOINED_EVENT,
		USER_LEFT_EVENT,
		REDIRECT,
		MACHINE_SUBSCRIBED_EVENT,
		MACHINE_UNSUBSCRIBED_EVENT
	}
};
